import React, {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {FleksupService} from '../../../services/FleksupService'

const initialValues = {
  email: '',
}

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Hatalı e-posta formatı')
    .min(3, 'En az 3 karakter girebilirsin.')
    .max(50, 'En fazla 50 karakter girebilirsin.')
    .required('E-posta alanı zorunludur.'),
})

export function ForgotPassword() {
  const [btnLoading, setBtnLoading] = useState(false)
  const [status, setStatus] = useState<any>({})
  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values) => {
      setBtnLoading(true)
      FleksupService.recoverPassword(values.email)
        .then((res) => {
          if (res.data.successful) {
            setStatus({
              type: 'success',
              message: 'Şifre sıfırlama mailiniz e-posta adresinize gönderildi.',
            })
          }
          if (res.status === 204) {
            setStatus({
              type: 'danger',
              message: 'E-posta adresinize şifre sıfırlama bağlantısı gönderirken bir hata oluştu.',
            })
          }
          setBtnLoading(false)
        })
        .catch((err) => {
          setStatus({
            type: 'danger',
            message: 'E-posta adresinize şifre sıfırlama bağlantısı gönderirken bir hata oluştu.',
          })
          setBtnLoading(false)
        })
    },
  })

  return (
    <>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_password_reset_form'
        onSubmit={formik.handleSubmit}
      >
        <div className='text-center mb-10'>
          {/* begin::Title */}
          <h1 className='text-dark mb-3'>Şifreni mi unuttun?</h1>
          {/* end::Title */}

          {/* begin::Link */}
          <div className='text-gray-400 fw-bold fs-4'>
            E-posta adresine şifreni sıfırlaman için bağlantı göndereceğiz.
          </div>
          {/* end::Link */}
        </div>
        {status && (
          <div className={`mb-lg-15 alert alert-${status.type}`}>
            <div className='alert-text font-weight-bold'>{status.message}</div>
          </div>
        )}

        {/* begin::Form group */}
        <div className='fv-row mb-10'>
          <label className='form-label fw-bolder text-gray-900 fs-6'>E-posta</label>
          <input
            type='email'
            placeholder='E-posta adresinizi giriniz'
            autoComplete='off'
            {...formik.getFieldProps('email')}
            className={clsx(
              'form-control form-control-lg form-control-solid',
              {'is-invalid': formik.touched.email && formik.errors.email},
              {
                'is-valid': formik.touched.email && !formik.errors.email,
              }
            )}
          />
          {formik.touched.email && formik.errors.email && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{formik.errors.email}</span>
              </div>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
          <button
            type='submit'
            id='kt_password_reset_submit'
            className='btn btn-lg btn-primary fw-bolder me-4'
            disabled={btnLoading}
          >
            {!btnLoading && 'Gönder'}
            {btnLoading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Lütfen bekleyin...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
          <Link to='/account/login'>
            <button
              type='button'
              id='kt_login_password_reset_form_cancel_button'
              className='btn btn-lg btn-light-primary fw-bolder'
            >
              Giriş Yap
            </button>
          </Link>{' '}
        </div>
        {/* end::Form group */}
      </form>
    </>
  )
}
